import { apiFetch } from "./client";

export function loginAdmin(payload) {
  return apiFetch("/api/admin/login", {
    method: "POST",
    body: JSON.stringify(payload), // { username, password }
  });
}
